import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { AccountListItemDto } from '../models/dto/account-list-item-dto';

export class CustomerApi {
    constructor(protected baseUrl: string) {}

    public getCustomers = (params: URLSearchParams): Promise<ApiResult<PaginatedResponse<AccountListItemDto>>> =>
        safeRequest(
            () => request.get<PaginatedResponse<AccountListItemDto>>(`${this.baseUrl}/customers`, { params }),
            response => response.data
        );
}
